import React, {FC} from 'react';
import {BrowserRouter, Routes, Route} from 'react-router-dom';
import {useAuth} from '../contexts/UserContext';
import {ForgotPassword} from '../pages/auth/forgot-password';
import {Login} from '../pages/auth/login';
import {UpdatePassword} from '../pages/auth/update-password';
import { NotFound } from '../pages/not-found';
import {UnitOverview} from '../pages/units/unit-overview';
import {UnitEvent} from '../pages/units/unit-event';
import {AccountList} from '../pages/account-list';
import {UnitLocation} from '../pages/units/unit-location';
import { AuthProtectedPage } from '../components/auth-protected-page/auth-protected-page.component';

export const Router: FC = () => {

  const { isLoggedIn } = useAuth();

  return (
    <BrowserRouter>
      <Routes>
        {
     
          <>
            <Route path="/" element={isLoggedIn ? <AccountList /> : <Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<UpdatePassword />} />
            <Route path="units/:unitId" element={<AuthProtectedPage><UnitOverview /></AuthProtectedPage>}  />
            <Route path="units/:unitId/location/:locationId" element={<AuthProtectedPage><UnitLocation /></AuthProtectedPage>} />
            <Route path="units/:unitId/event/:eventId" element={<AuthProtectedPage><UnitEvent /></AuthProtectedPage>} />
            <Route path="*" element={<NotFound/>} />
          </>
        }
      </Routes>
    </BrowserRouter>
  );
};
